export enum StepType {
  Active = 'active',
  Completed = 'completed',
  Default = 'default',
}
